










































































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";
import { Location } from "vue-router";
import { UserListActionButtonOptions, UserSearchResultModel } from "@/admin/types";
import PageSizeSelectList from "@/shared/components/ui/PageSizeSelectList.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserSearchStore } from "@/admin/store/userSearch";

@Component({
  components: {
    PageSizeSelectList,
    Pagination
  }
})
export default class Users extends Vue {

  notifierStore = useNotifierStore();
  userSearchStore = useUserSearchStore();

  isSubmitting = false;
  searchTerm = "";
  users: UserSearchResultModel[] = [];

  @Prop({ default: () => ({ show: false, text: "" }) })
  actionButtonOptions: UserListActionButtonOptions;

  @Prop()
  page: number;

  @Prop()
  routeToUserList: (page: number) => Location;

  @Prop({ default: "" })
  subtitle: string;

  @Prop({ default: "Users" })
  title: string;

  @Prop({ default: false })
  refreshData: boolean;

  mounted (): void {
    this.fetchUserList(false);
  }

  get submitDisabled (): boolean {
    return this.userSearchStore.isLoading || this.isSubmitting;
  }

  @Watch("page")
  onRouteValuePageNumberChanged (): void {
    this.fetchUserList(false);
  }

  @Watch("refreshData")
  onRefreshData (): void {
    this.fetchUserList(true);
  }

  switchPage (toPage: number): void {
    this.$router.push(this.routeToUserList(toPage));
  }

  fetchUserList (clearState: boolean): void {
    if (!clearState) {
      this.userSearchStore.setPageNumber(this.page);
    }

    this.userSearchStore.loadUsers({
      clearState,
      pageNumber: this.userSearchStore.pageNumber,
      searchTerm: this.searchTerm
    } as any)
      .then(() => {
        this.users = this.userSearchStore.getUsersByPageNumber(this.userSearchStore.pageNumber);
      })
      .catch(this.handleError);
  }

  onSearch (): void {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.userSearchStore.setPageNumber(1);
    this.$router.push(this.routeToUserList(1));
    this.fetchUserList(true);
    this.isSubmitting = false;
  }

  clearSearch (): void {
    if (this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.searchTerm = "";
    this.userSearchStore.setPageNumber(1);
    this.$router.push(this.routeToUserList(1));
    this.fetchUserList(true);
    this.isSubmitting = false;
  }

  switchPageSize (): void {
    this.userSearchStore.setPageNumber(1);
    this.$router.push(this.routeToUserList(1));
    this.fetchUserList(true);
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
      (err && err.errorMessage) ||
      "Error processing your request. Please try again later"
    );
  }
}
